function paramsToObject(entries) {
  let result = {}
  for (let entry of entries) {
    const [key, value] = entry;
    result[key] = value;
  }

  return result;
}

export default paramsToObject;